import styled from "styled-components";

export const FormRowBtn = styled.button`
  position: relative;
  display: inline-block;
  height: 45px;
  padding: 0 1.5rem;
  margin: 0;
  color: white;
  -webkit-text-decoration: none;
  text-decoration: none;
  border-radius: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border: 1px solid transparent;
  font-size: 1.1rem;
  line-height: 1rem;
  font-family: var(--font-urw-din);
  font-weight: 500;
  text-transform: uppercase;
  word-break: keep-all;
  cursor: pointer;
  background-color: black;
  width: 100% !important;

  &:hover {
    border: 1px solid transparent;
    background-image: linear-gradient(#373737, black);
    transition: background-color 400ms ease-in;
    text-decoration: none;
  }

  &:active {
    border: 1px solid transparent;
    text-decoration: none;
    background-image: linear-gradient(black, #373737);
    transition: background-color 400ms ease-in;
    text-decoration: none;
  }
`;
